import React, { useState, useEffect } from "react";
import {
  Book,
  Map,
  Tent,
  Music,
  Send,
  LucideWifiOff,
  MoreHorizontalIcon,
} from "lucide-react";

export const FeatureSection = () => {
  const isVisible = (elementOffset) => {
    return scrollY > elementOffset - window.innerHeight + 100;
  };

  const FeatureCard = ({ icon, title, description }) => {
    return (
      <div className="bg-white/5 p-6 rounded-xl backdrop-blur-sm hover:bg-white/10 transition border border-[#FF4D00]/10">
        <div className="w-12 h-12 bg-[#FF4D00]/20 rounded-lg flex items-center justify-center mb-4">
          {React.cloneElement(icon, { className: "w-6 h-6 text-[#FF4D00]" })}
        </div>
        <h3 className="text-xl font-semibold mb-2">{title}</h3>
        <p className="text-gray-400">{description}</p>
      </div>
    );
  };

  return (
    <section className="py-20 px-4 relative bg-zinc-900">
      <div className="absolute inset-0 bg-[#1a1a1a]/50"></div>
      <div className="max-w-6xl mx-auto relative z-10">
        <div
          className={`transform transition-all duration-1000 ${
            isVisible(300)
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-10"
          }`}
        >
          <h2 className="text-4xl/[1.5] font-bold text-center mb-16 text-[#FF4D00]">
            Everything your visitors need in one app
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <FeatureCard
              icon={<Music />}
              title="Running Order"
              description="Never miss your favorite artists with our detailed schedule view and save your favorites in your personal program"
            />
            <FeatureCard
              icon={<Send />}
              title="Real-time Updates"
              description="Send instant notifications to your visitors about schedule changes and announcements"
            />
            <FeatureCard
              icon={<Map />}
              title="Interactive Map"
              description="Locate stages, facilities, and food vendors with our detailed map"
            />
            <FeatureCard
              icon={<Tent />}
              title="Camping Info"
              description="Find the best spots and navigate the camping grounds easily"
            />
            <FeatureCard
              icon={<Book />}
              title="Festival Guide"
              description="Access all important information about the festival in one app"
            />
            <FeatureCard
              icon={<LucideWifiOff />}
              title="Offline Access"
              description="All information available offline - no internet required"
            />
            <FeatureCard
              icon={<MoreHorizontalIcon />}
              title="...and so much more!"
              description="Contact us and find out what else Helga can do for you and your visitors!"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
